import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { pxToNumber } from '../../../../utils/pxToNumber'
import * as NavListItemStyled from '../NavListItemView/styles'

export const SubItemWrapper = styled(NavListItemStyled.NavListItemViewWrapper)``

export const SubItem = styled(NavListItemStyled.NavListItemView)`
  height: auto;
  min-height: 32px;
  padding: ${Spacing.S4} ${Spacing.S4} ${Spacing.S4} ${pxToNumber(Spacing.S40) + pxToNumber(Spacing.S4)}px;
`
